export const cleanUrl = (str) => str.replace(/([^:]\/)\/+/g, '$1')
// export const removeTrailingSlash = (str) =>
//   str.endsWith('/') ? str.slice(0, -1) : str
